import {Module, Mutation, VuexModule} from "vuex-module-decorators";
import {ModelPointsData} from "@/models/ModelPointsData";
import {CategoryModel} from "@/models/CategoryModel";
import {Config} from "@/settings/Config";

// Import all model data
import {c40ModelData} from "./car-models/c40";
import {ec40ModelData} from "./car-models/ec40";
import {ex30ModelData} from "./car-models/ex30";
import {ex30ccModelData} from "./car-models/ex30cc";
import {ex40ModelData} from "./car-models/ex40";
import {ex90ModelData} from "./car-models/ex90";
import {s60ModelData} from "./car-models/s60";
import {s90ModelData} from "./car-models/s90";
import {v60ModelData} from "./car-models/v60";
import {v60ccModelData} from "./car-models/v60cc";
import {v90ModelData} from "./car-models/v90";
import {v90ccModelData} from "./car-models/v90cc";
import {xc40ModelData} from "./car-models/xc40";
import {xc60ModelData} from "./car-models/xc60";
import {xc90ModelData} from "./car-models/xc90";
import {es90ModelData} from "./car-models/es90";

@Module({
    name: "carModelsModule",
})
export default class carModelsModule extends VuexModule {
    private readonly _config = new Config();

    private _modelsPoints: ModelPointsData[] = [
        c40ModelData,
        ec40ModelData,
        ex30ModelData,
        ex30ccModelData,
        ex40ModelData,
        ex90ModelData,
        s60ModelData,
        s90ModelData,
        v60ModelData,
        v60ccModelData,
        v90ModelData,
        v90ccModelData,
        xc40ModelData,
        xc60ModelData,
        xc90ModelData,
        es90ModelData,
    ];

    private _activePointCategoryNodeId: string | undefined = undefined;
    private _activePointHoverImg: string | undefined = undefined;
    private _activePointHoverIsImage: boolean | undefined = undefined;

    public get activePointCategoryNodeId(): string {
        return this._activePointCategoryNodeId;
    }

    public get activePointHoverImg(): string {
        return this._activePointHoverImg;
    }

    public get activePointHoverIsImage(): boolean {
        return this._activePointHoverIsImage;
    }

    @Mutation
    setActivePointCategoryId(categoryNodeId: string | undefined): void {
        this._activePointCategoryNodeId = categoryNodeId;
    }

    @Mutation
    setActivePointHoverImg(hoverImg: string | undefined): void {
        this._activePointHoverImg = hoverImg;
    }

    @Mutation
    setActivePointHoverIsImage(type: string | undefined): void {
        this._activePointHoverIsImage = undefined;
        if (type === "image") {
            this._activePointHoverIsImage = true;
        }
        if (type === "video") {
            this._activePointHoverIsImage = false;
        }
    }

    public get modelPointsByModel() {
        return (model: string): ModelPointsData[] | undefined => {
            return this._modelsPoints.filter((m) => {
                if (m.model === model) {
                    return true;
                }
            });
        };
    }

    public get isActivePointCategory() {
        return (category: CategoryModel): boolean => {
            return this._config.useNewContentNodes
                ? category.nodeId === this._activePointCategoryNodeId
                : category.id === this._activePointCategoryNodeId;
        }
    }
}
